<template>
  <section id="report">
    <div class="mb-4 card">
      <div class="d-sm-flex justify-content-between p-2 pb-3">
        <h4 class="mb-sm-0 pt-2">
          <a href="/dashboard">Home Page</a><span>/</span><span>Dashboard</span><span>/</span><b>Report</b>
        </h4>
      </div>
    </div>
    <section class="mt-lg-1" v-if="currentPage == 'report'">
      <mdb-row>
        <mdb-col md="4" class="mb-r">
          <mdb-card
            cascade
            class="cascading-admin-card classic-admin-card bg-dark white-text"
          >
            
            <mdb-card-body>
              <label>Search Student</label>
              <input type="text" v-model="searchStudent" class="form-control mb-4">
              <button class="btn btn-outline-white btn-block btn-sm" @click.prevent="searchStudentF()">
                Seach Students
              </button>
            </mdb-card-body>
          </mdb-card>
        </mdb-col>

        <mdb-col md="4" class="mb-r">
          <mdb-card
            cascade
            class="cascading-admin-card classic-admin-card bg-dark white-text"
          >
            
            <mdb-card-body>
              <label>Search Teacher</label>
              <input type="text" v-model="searchTeacher" class="form-control mb-4">
              <button class="btn btn-outline-white btn-block btn-sm" @click.prevent="searchTeacherF()">
                Seach Teacher
              </button>
            </mdb-card-body>
          </mdb-card>
        </mdb-col>

        <mdb-col md="4" class="mb-r">
          <mdb-card
            cascade
            class="cascading-admin-card classic-admin-card bg-dark white-text"
          >
            
            <mdb-card-body>
              <label>Search By Class</label>
              <input type="text" v-model="searchClass" class="form-control mb-4">
              <button class="btn btn-outline-white btn-block btn-sm" @click.prevent="searchClassF()">
                Seach By Class
              </button>
            </mdb-card-body>
          </mdb-card>
        </mdb-col>

        <mdb-col md="6" class="mb-r">
          <mdb-card
            cascade
            class="cascading-admin-card classic-admin-card bg-dark white-text"
          >
            
            <mdb-card-body>
              <label>Search By Group</label>
                <select class="form-control mb-4" v-model="searchGroup">
                  <option selected disabled>-- Select A Group --</option>
                  <option
                    v-for="group in totalGroups"
                    :key="group.group"
                    v-bind:value="group.group"
                  >
                  Group  {{ group.group }}
                  </option>
                </select>
                <button class="btn btn-outline-white btn-block btn-sm" @click.prevent="searchGroupF()">
                  Seach By Group
                </button>
            </mdb-card-body>
          </mdb-card>
        </mdb-col>

        <mdb-col md="6" class="mb-r">
          <mdb-card
            cascade
            class="cascading-admin-card classic-admin-card bg-dark white-text"
          >
            
            <mdb-card-body>
              <label>Search By Type</label>
                <select class="form-control mb-4" v-model="searchType">
                  <option selected disabled>-- Select A Type --</option>
                  <option
                    v-for="stype in totalTypes"
                    :key="stype"
                    v-bind:value="stype"
                  >
                  {{ stype }}
                  </option>
                </select>
              <button class="btn btn-outline-white btn-block btn-sm" @click.prevent="searchTypeF()">
                Search By Type
              </button>
            </mdb-card-body>
          </mdb-card>
        </mdb-col>

        <mdb-col md="6" class="mb-r">
          <mdb-card
            cascade
            class="cascading-admin-card classic-admin-card bg-dark white-text"
          >
            
            <mdb-card-body>
              <label>Search By Program</label>
                <select class="form-control mb-4" v-model="searchProgram">
                  <option selected disabled>-- Select A Program --</option>
                  <option
                    v-for="value in totalPrograms"
                    :key="value"
                    v-bind:value="value"
                  >
                  {{ value }}
                  </option>
                </select>
                <button class="btn btn-outline-white btn-block btn-sm" @click.prevent="searchProgramF()">
                Search By Program
              </button>
            </mdb-card-body>
          </mdb-card>
        </mdb-col>

        <mdb-col md="6" class="mb-r">
          <mdb-card
            cascade
            class="cascading-admin-card classic-admin-card bg-dark white-text"
          >
            
            <mdb-card-body>
              <label>Search By Level</label>
                  <select class="form-control mb-4" v-model="searchLevel">
                    <option selected disabled>-- Select A Level --</option>
                    <option
                      v-for="level in totalLevels"
                      :key="level._id"
                      v-bind:value="level.target + ' ' + level.step"
                    >
                    {{ level.target }}  {{ level.step }}
                    </option>
                  </select>
                <button class="btn btn-outline-white btn-block btn-sm" @click.prevent="searchLevelF()">
                Search By Level
              </button>
            </mdb-card-body>
          </mdb-card>
        </mdb-col>

      </mdb-row>
    </section>

    <section class="mt-lg-1" v-if="currentPage == 'search-student'">
      <mdb-row>
        <mdb-col md="12" class="mb-r">
          <mdb-card
            cascade
            class="cascading-admin-card classic-admin-card bg-dark white-text"
          >
            
            <mdb-card-body>
              <label @click.prevent="returnReport()"><mdb-icon icon="arrow-left" fas class="bg-dark mr-2" /> Search Student</label>
              <mdb-row>
                <mdb-col md="6">
                  <input type="text" v-model="searchStudent" class="form-control">
                </mdb-col>
                <mdb-col md="2">
                  <button class="btn btn-outline-white btn-block btn-sm mt-1" @click.prevent="searchStudentF()">
                    Seach
                  </button>
                </mdb-col>
                <mdb-col md="2">
                  <button class="btn btn-outline-white btn-block btn-sm mt-1"  @click.prevent="getAllStudents()">
                    All
                  </button>
                </mdb-col>
                <mdb-col md="2">
                  <button class="btn btn-outline-white btn-block btn-sm mt-1" @click.prevent="downloadCSV()">
                    CSV
                  </button>
                </mdb-col>
              </mdb-row>
              
            </mdb-card-body>
          </mdb-card>
        </mdb-col>
      </mdb-row>
    </section>

    <section class="mt-lg-1" v-if="currentPage == 'search-teacher'">
      <mdb-row>
        <mdb-col md="12" class="mb-r">
          <mdb-card
            cascade
            class="cascading-admin-card classic-admin-card bg-dark white-text"
          >
            
            <mdb-card-body>
              <label @click.prevent="returnReport()"><mdb-icon icon="arrow-left" fas class="bg-dark mr-2" /> Search Teacher</label>
              <mdb-row>
                <mdb-col md="6">
                  <input type="text" v-model="searchTeacher" class="form-control">
                </mdb-col>
                <mdb-col md="2">
                  <button class="btn btn-outline-white btn-block btn-sm mt-1" @click.prevent="searchTeacherF()">
                    Seach
                  </button>
                </mdb-col>
                <mdb-col md="2">
                  <button class="btn btn-outline-white btn-block btn-sm mt-1"  @click.prevent="getAllTeachers()">
                    All
                  </button>
                </mdb-col>
                <mdb-col md="2">
                  <button class="btn btn-outline-white btn-block btn-sm mt-1" @click.prevent="downloadCSV()">
                    CSV
                  </button>
                </mdb-col>
              </mdb-row>
              
            </mdb-card-body>
          </mdb-card>
        </mdb-col>
      </mdb-row>
    </section>

    <section class="mt-lg-1" v-if="currentPage == 'search-by-class'">
      <mdb-row>
        <mdb-col md="12" class="mb-r">
          <mdb-card
            cascade
            class="cascading-admin-card classic-admin-card bg-dark white-text"
          >
            
            <mdb-card-body>
              <label @click.prevent="returnReport()"><mdb-icon icon="arrow-left" fas class="bg-dark mr-2" /> Search By Class</label>
              <mdb-row>
                <mdb-col md="6">
                  <input type="text" v-model="searchClass" class="form-control">
                </mdb-col>
                <mdb-col md="2">
                  <button class="btn btn-outline-white btn-block btn-sm mt-1" @click.prevent="searchClassF()">
                    Seach
                  </button>
                </mdb-col>
                <mdb-col md="2">
                  <button class="btn btn-outline-white btn-block btn-sm mt-1"  @click.prevent="getAllStudents()">
                    All
                  </button>
                </mdb-col>
                <mdb-col md="2">
                  <button class="btn btn-outline-white btn-block btn-sm mt-1" @click.prevent="downloadCSV()">
                    CSV
                  </button>
                </mdb-col>
              </mdb-row>
              
            </mdb-card-body>
          </mdb-card>
        </mdb-col>
      </mdb-row>
    </section>

    <section class="mt-lg-1" v-if="currentPage == 'search-by-group'">
      <mdb-row>
        <mdb-col md="12" class="mb-r">
          <mdb-card
            cascade
            class="cascading-admin-card classic-admin-card bg-dark white-text"
          >
            
            <mdb-card-body>
              <label @click.prevent="returnReport()"><mdb-icon icon="arrow-left" fas class="bg-dark mr-2" /> Search By Group</label>
              <mdb-row>
                <mdb-col md="6">
                  <select class="form-control" v-model="searchGroup">
                    <option selected disabled>-- Select A Group --</option>
                    <option
                      v-for="group in totalGroups"
                      :key="group.group"
                      v-bind:value="group.group"
                    >
                    Group  {{ group.group }}
                    </option>
                  </select>
                </mdb-col>
                <mdb-col md="2">
                  <button class="btn btn-outline-white btn-block btn-sm mt-1" @click.prevent="searchGroupF()">
                    Seach
                  </button>
                </mdb-col>
                <mdb-col md="2">
                  <button class="btn btn-outline-white btn-block btn-sm mt-1"  @click.prevent="getAllStudents()">
                    All
                  </button>
                </mdb-col>
                <mdb-col md="2">
                  <button class="btn btn-outline-white btn-block btn-sm mt-1" @click.prevent="downloadCSV()">
                    CSV
                  </button>
                </mdb-col>
              </mdb-row>
              
            </mdb-card-body>
          </mdb-card>
        </mdb-col>
      </mdb-row>
    </section>

    <section class="mt-lg-1" v-if="currentPage == 'search-by-type'">
      <mdb-row>
        <mdb-col md="12" class="mb-r">
          <mdb-card
            cascade
            class="cascading-admin-card classic-admin-card bg-dark white-text"
          >
            
            <mdb-card-body>
              <label @click.prevent="returnReport()"><mdb-icon icon="arrow-left" fas class="bg-dark mr-2" /> Search By Type</label>
              <mdb-row>
                <mdb-col md="6">
                <select class="form-control" v-model="searchType">
                  <option selected disabled>-- Select A Type --</option>
                  <option
                    v-for="stype in totalTypes"
                    :key="stype"
                    v-bind:value="stype"
                  >
                  {{ stype }}
                  </option>
                </select>
                </mdb-col>
                <mdb-col md="2">
                  <button class="btn btn-outline-white btn-block btn-sm mt-1" @click.prevent="searchTypeF()">
                    Seach
                  </button>
                </mdb-col>
                <mdb-col md="2">
                  <button class="btn btn-outline-white btn-block btn-sm mt-1"  @click.prevent="getAllStudents()">
                    All
                  </button>
                </mdb-col>
                <mdb-col md="2">
                  <button class="btn btn-outline-white btn-block btn-sm mt-1" @click.prevent="downloadCSV()">
                    CSV
                  </button>
                </mdb-col>
              </mdb-row>
              
            </mdb-card-body>
          </mdb-card>
        </mdb-col>
      </mdb-row>
    </section>

    <section class="mt-lg-1" v-if="currentPage == 'search-by-program'">
      <mdb-row>
        <mdb-col md="12" class="mb-r">
          <mdb-card
            cascade
            class="cascading-admin-card classic-admin-card bg-dark white-text"
          >
            
            <mdb-card-body>
              <label @click.prevent="returnReport()"><mdb-icon icon="arrow-left" fas class="bg-dark mr-2" /> Search By Program</label>
              <mdb-row>
                <mdb-col md="6">
                <select class="form-control" v-model="searchProgram">
                  <option selected disabled>-- Select A Program --</option>
                  <option
                    v-for="value in totalPrograms"
                    :key="value"
                    v-bind:value="value"
                  >
                  {{ value }}
                  </option>
                </select>
                </mdb-col>
                <mdb-col md="2">
                  <button class="btn btn-outline-white btn-block btn-sm mt-1" @click.prevent="searchProgramF()">
                    Seach
                  </button>
                </mdb-col>
                <mdb-col md="2">
                  <button class="btn btn-outline-white btn-block btn-sm mt-1"  @click.prevent="getAllStudents()">
                    All
                  </button>
                </mdb-col>
                <mdb-col md="2">
                  <button class="btn btn-outline-white btn-block btn-sm mt-1" @click.prevent="downloadCSV()">
                    CSV
                  </button>
                </mdb-col>
              </mdb-row>
              
            </mdb-card-body>
          </mdb-card>
        </mdb-col>
      </mdb-row>
    </section>

    <section class="mt-lg-1" v-if="currentPage == 'search-by-level'">
      <mdb-row>
        <mdb-col md="12" class="mb-r">
          <mdb-card
            cascade
            class="cascading-admin-card classic-admin-card bg-dark white-text"
          >
            
            <mdb-card-body>
              <label @click.prevent="returnReport()"><mdb-icon icon="arrow-left" fas class="bg-dark mr-2" /> Search By Level</label>
              <mdb-row>
                <mdb-col md="6">
                  <select class="form-control" v-model="searchLevel">
                    <option selected disabled>-- Select A Level --</option>
                    <option
                      v-for="level in totalLevels"
                      :key="level._id"
                      v-bind:value="level.target + ' ' + level.step"
                    >
                    {{ level.target }}  {{ level.step }}
                    </option>
                  </select>
                </mdb-col>
                <mdb-col md="2">
                  <button class="btn btn-outline-white btn-block btn-sm mt-1" @click.prevent="searchLevelF()">
                    Seach
                  </button>
                </mdb-col>
                <mdb-col md="2">
                  <button class="btn btn-outline-white btn-block btn-sm mt-1"  @click.prevent="getAllStudents()">
                    All
                  </button>
                </mdb-col>
                <mdb-col md="2">
                  <button class="btn btn-outline-white btn-block btn-sm mt-1" @click.prevent="downloadCSV()">
                    CSV
                  </button>
                </mdb-col>
              </mdb-row>
              
            </mdb-card-body>
          </mdb-card>
        </mdb-col>
      </mdb-row>
    </section>

    <section class="mt-lg-1 students-view" v-if="currentPage != 'search-teacher' && currentPage != 'report'">
      <div class="table-responsive">
        <table class="table table-bordered">
          <thead class="thead-dark">
            <tr>
              <th scope="col">Name</th>
              <th scope="col">First Name</th>
              <th scope="col">Last Name</th>
              <th scope="col">User Name</th>
              <th scope="col">Age Bracket</th>
              <th scope="col">Level</th>
              <th scope="col">School Grade</th>
              <th scope="col">Type</th>
              <th scope="col">Class</th>
              <th scope="col">Group #</th>
              <th scope="col">City</th>
              <th scope="col">Guardian Name</th>
              <th scope="col">Guardian Email</th>
              <th scope="col">Guardian Phone</th>
              <th scope="col">Take Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="student in students" :key="student._id">
              <th>{{ student.name }}</th>
              <th>{{ student.first_name }}</th>
              <td>{{ student.last_name }}</td>
              <td>{{ student.username }}</td>
              <td>{{ student.age_bracket }}</td>
              <td>{{ student.level }}</td>
              <td>{{ student.school_grade }}</td>
              <td>{{ student.type }}</td>
              <td>{{ student.class }}</td>
              <td>{{ student.group }}</td>
              <td>{{ student.city }}</td>
              <td>{{ student.guardian_name }}</td>
              <td>{{ student.guardian_email }}</td>
              <td>{{ student.guardian_phone }}</td>
              <td>
               
                <button
                  class="btn btn-success btn-sm btn-block"
                  v-if="student.disabled"
                  @click="activate(student._id)"
                >
                  Activate
                </button>

                <button
                  class="btn btn-dark btn-sm btn-block"
                  v-if="student.disabled == false"
                  @click="deactivate(student._id)"
                >
                  Deactivate
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <section class="mt-lg-1 teachers-view" v-if="currentPage == 'search-teacher'">
        <div class="table-responsive">
            <table class="table table-bordered">
                <thead class="thead-dark">
                    <tr>
                        <th scope="col">First Name</th>
                        <th scope="col">Last Name</th>
                        <th scope="col">Email</th>
                        <th scope="col">City</th>
                        <th scope="col">Take Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(teacher) in teachers" :key="teacher._id">
                        <th>{{teacher.first_name}}</th>
                        <td>{{teacher.last_name}}</td>
                        <td>{{teacher.email}}</td>
                        <td>{{teacher.city}}</td>
                        <td>
                            <router-link :to="{ name: 'EditTeacher', params : {user_id : teacher._id} }">
                                <button class="btn btn-info btn-sm">Edit</button>
                            </router-link>

                            <button class="btn btn-success btn-sm " v-if="teacher.disabled" @click="activate(teacher._id)">Activate</button>

                            <button class="btn btn-dark btn-sm" v-if="teacher.disabled == false" @click="deactivate(teacher._id)">Deactivate</button>

                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </section>

  </section>
</template>

<script>
import axios from "axios";
import { mdbRow, mdbCol, mdbCard, mdbCardBody, mdbIcon} from "mdbvue";

export default {
  name: "Report",
  components: {
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardBody,
    mdbIcon,
  },
  data() {
    return {
      totalGroups: [],
      totalLevels: [],
      totalTypes: ['School', 'After School'],
      totalPrograms: ['Runner', 'Toddler'],
      students: [],
      teachers: [],
      currentPage: 'report',
      searchStudent: '',
      searchTeacher: '',
      searchClass: '',
      searchGroup: '',
      searchType: '',
      searchProgram: '',
      searchLevel: '',
      
      fastAdminToken: localStorage.getItem("fastAdminToken"),
    };
  },

  methods: {
    searchStudentF() {

      if(this.searchStudent == '') {
        this.$toast.open({
            message: "Error: Please input student info",
            type: 'error'
        });
        return;
      }

      this.currentPage = 'search-student';

      
      const config = {
          headers: {
              Authorization: "Bearer " + this.fastAdminToken,
              'Content-Type': 'application/json'
          }
      }

      let data = {
        type: 'search',
        value: this.searchStudent
      };

      axios.post(this.$apiURI + "/account/search-students", data, config)
          .then((response) => {
              if (response.data.error) {
                  this.$toast.open({
                      message: "Error : " + response.data.message,
                      type: 'error'
                  });
              } else {
                  
                  // eslint-disable-next-line no-console
                  // console.log(response.data.data.teachers)
                  this.students = response.data.data.students
              }

          }).catch((error) => {
              this.$toast.open({
                  message: "Error : " + error.response.data.message,
                  type: 'error'
              });
          })

    },

    searchTeacherF() {

      if(this.searchTeacher == '') {
        this.$toast.open({
            message: "Error: Please input teacher info",
            type: 'error'
        });
        return;
      }

      this.currentPage = 'search-teacher';


        const config = {
            headers: {
                Authorization: "Bearer " + this.fastAdminToken,
                'Content-Type': 'application/json'
            }
        }

        let data = {
          searchKey: this.searchTeacher
        };

        axios.post(this.$apiURI + "/account/search-teachers", data, config)
            .then((response) => {
                if (response.data.error) {
                    this.$toast.open({
                        message: "Error : " + response.data.message,
                        type: 'error'
                    });
                } else {
                    
                    // eslint-disable-next-line no-console
                    // console.log(response.data.data.teachers)
                    this.teachers = response.data.data.teachers
                }

            }).catch((error) => {
                this.$toast.open({
                    message: "Error : " + error.response.data.message,
                    type: 'error'
                });
            })
    },

    searchClassF() {

      if(this.searchClass == '') {
        this.$toast.open({
            message: "Error: Please input class name",
            type: 'error'
        });
        return;
      }

      this.currentPage = 'search-by-class';

      const config = {
          headers: {
              Authorization: "Bearer " + this.fastAdminToken,
              'Content-Type': 'application/json'
          }
      }

      let data = {
        type: 'class',
        value: this.searchClass
      };

      axios.post(this.$apiURI + "/account/search-students", data, config)
          .then((response) => {
              if (response.data.error) {
                  this.$toast.open({
                      message: "Error : " + response.data.message,
                      type: 'error'
                  });
              } else {
                  
                  // eslint-disable-next-line no-console
                  // console.log(response.data.data.teachers)
                  this.students = response.data.data.students
              }

          }).catch((error) => {
              this.$toast.open({
                  message: "Error : " + error.response.data.message,
                  type: 'error'
              });
          })


    },

    searchGroupF() {

      if(this.searchGroup == '') {
        this.$toast.open({
            message: "Error: Please select a group",
            type: 'error'
        });
        return;
      }

      this.currentPage = 'search-by-group';

      const config = {
          headers: {
              Authorization: "Bearer " + this.fastAdminToken,
              'Content-Type': 'application/json'
          }
      }

      let data = {
        type: 'group',
        value: this.searchGroup
      };

      axios.post(this.$apiURI + "/account/search-students", data, config)
          .then((response) => {
              if (response.data.error) {
                  this.$toast.open({
                      message: "Error : " + response.data.message,
                      type: 'error'
                  });
              } else {
                  
                  // eslint-disable-next-line no-console
                  // console.log(response.data.data.teachers)
                  this.students = response.data.data.students
              }

          }).catch((error) => {
              this.$toast.open({
                  message: "Error : " + error.response.data.message,
                  type: 'error'
              });
          })

    },

    searchTypeF() {

      if(this.searchType == '') {
        this.$toast.open({
            message: "Error: Please select a type",
            type: 'error'
        });
        return;
      }

      this.currentPage = 'search-by-type';

      const config = {
          headers: {
              Authorization: "Bearer " + this.fastAdminToken,
              'Content-Type': 'application/json'
          }
      }

      let data = {
        type: 'type',
        value: this.searchType
      };

      axios.post(this.$apiURI + "/account/search-students", data, config)
          .then((response) => {
              if (response.data.error) {
                  this.$toast.open({
                      message: "Error : " + response.data.message,
                      type: 'error'
                  });
              } else {
                  
                  // eslint-disable-next-line no-console
                  // console.log(response.data.data.teachers)
                  this.students = response.data.data.students
              }

          }).catch((error) => {
              this.$toast.open({
                  message: "Error : " + error.response.data.message,
                  type: 'error'
              });
          })

    },

    searchProgramF() {

      if(this.searchProgram == '') {
        this.$toast.open({
            message: "Error: Please select a program",
            type: 'error'
        });
        return;
      }

      this.currentPage = 'search-by-program';

      const config = {
          headers: {
              Authorization: "Bearer " + this.fastAdminToken,
              'Content-Type': 'application/json'
          }
      }

      let data = {
        type: 'program',
        value: this.searchProgram
      };

      axios.post(this.$apiURI + "/account/search-students", data, config)
          .then((response) => {
              if (response.data.error) {
                  this.$toast.open({
                      message: "Error : " + response.data.message,
                      type: 'error'
                  });
              } else {
                  
                  // eslint-disable-next-line no-console
                  // console.log(response.data.data.teachers)
                  this.students = response.data.data.students
              }

          }).catch((error) => {
              this.$toast.open({
                  message: "Error : " + error.response.data.message,
                  type: 'error'
              });
          })

    },

    searchLevelF() {

      if(this.searchLevel == '') {
        this.$toast.open({
            message: "Error: Please select a level",
            type: 'error'
        });
        return;
      }

      this.currentPage = 'search-by-level';

      const config = {
          headers: {
              Authorization: "Bearer " + this.fastAdminToken,
              'Content-Type': 'application/json'
          }
      }

      let data = {
        type: 'level',
        value: this.searchLevel
      };

      axios.post(this.$apiURI + "/account/search-students", data, config)
          .then((response) => {
              if (response.data.error) {
                  this.$toast.open({
                      message: "Error : " + response.data.message,
                      type: 'error'
                  });
              } else {
                  
                  // eslint-disable-next-line no-console
                  // console.log(response.data.data.teachers)
                  this.students = response.data.data.students
              }

          }).catch((error) => {
              this.$toast.open({
                  message: "Error : " + error.response.data.message,
                  type: 'error'
              });
          })

    },

    returnReport() {
      this.currentPage = 'report';
      this.initData();
    },

    getAllStudents() {

      this.initData();
      const config = {
          headers: {
              Authorization: "Bearer " + this.fastAdminToken,
              'Content-Type': 'application/json'
          }
      }
      axios
        .get(this.$apiURI + "/account/students", config)
        .then((response) => {
          if (response.data.error) {
            this.$toast.open({
              message: "Error : " + response.data.message,
              type: "error",
            });
          } else {
            // eslint-disable-next-line no-console
            // console.log(response.data.data.teachers)
            this.students = response.data.data.students;
          }
        })
        .catch((error) => {
          this.$toast.open({
            message: "Error : " + error.response.data.message,
            type: "error",
          });
        });
    },

    getAllTeachers() {

        this.initData();

        const config = {
            headers: {
                Authorization: "Bearer " + this.fastAdminToken,
                'Content-Type': 'application/json'
            }
        }


        axios.get(this.$apiURI + "/account/teachers", config)
            .then((response) => {
                if (response.data.error) {
                    this.$toast.open({
                        message: "Error : " + response.data.message,
                        type: 'error'
                    });
                } else {
                    
                    // eslint-disable-next-line no-console
                    // console.log(response.data.data.teachers)
                    this.teachers = response.data.data.teachers
                }

            }).catch((error) => {
                this.$toast.open({
                    message: "Error : " + error.response.data.message,
                    type: 'error'
                });
            })
    },

    downloadCSV() {
      if(this.currentPage == 'search-teacher') {
        this.exportToCsv('teachers.csv', this.teachers);
      } else {
        this.exportToCsv('students.csv', this.students);
      }
    },

    exportToCsv(filename, rows) {
        let csv = '';
        // let header = Object.keys(rows[9]).join(',');
        let header = ['_id','first_name','last_name','middle_name','group','level','username','age_bracket','school_grade','city','county','country','guardian_email','teacher','date_joined','role','class','name','gender','type','registration_date','starting_age','class_day','class_schedule','date_assigned'];
        let values = '';
        Object.keys(rows).forEach(key => {
          Object.values(header).forEach(value => {
            values += rows[key][value] + ', '
          });
          values += '\n';
        });

        csv += header + '\n' + values;

        var blob = new Blob([csv], { type: 'text/csv;charset=utf-8,%EF%BB%BF' });
        if (navigator.msSaveBlob) { // IE 10+
            navigator.msSaveBlob(blob, filename);
        } else {
            var link = document.createElement("a");
            if (link.download !== undefined) { // feature detection
                // Browsers that support HTML5 download attribute
                var url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", filename);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    },

    initData() {
      this.searchStudent='';
      this.searchTeacher='';
      this.searchClass='';
      this.searchGroup='';
      this.searchType='';
      this.searchProgram='';
      this.searchLevel='';
    },

    activate(account_id) {
        const config = {
            headers: {
                Authorization: "Bearer " + this.fastAdminToken,
                'Content-Type': 'application/json'
            }
        }
        this.$toast.open({
            message: "Processing : Activating Account Please Wait...",
            type: 'info'
        })
        axios.post(this.$apiURI + "/account/" + account_id + "/activate", config)
            .then((response) => {
                if (response.data.error) {
                    this.$toast.open({
                        message: "Error : " + response.data.message,
                        type: 'error'
                    });
                } else {
                    this.$toast.open({
                        message: "Account Activated Successfully",
                        type: 'success'
                    })
                    window.location.reload();
                }

            }).catch((error) => {
                this.$toast.open({
                    message: "Error : " + error.response.data.message,
                    type: 'error'
                });
            })
    },
    deactivate(account_id) {
        const config = {
            headers: {
                Authorization: "Bearer " + this.fastAdminToken,
                'Content-Type': 'application/json'
            }
        }
        this.$toast.open({
            message: "Processing : Disabling Account Please Wait...",
            type: 'info'
        })
        axios.post(this.$apiURI + "/account/" + account_id + "/deactivate", config)
            .then((response) => {
                if (response.data.error) {
                    this.$toast.open({
                        message: "Error : " + response.data.message,
                        type: 'error'
                    });
                } else {
                    this.$toast.open({
                        message: "Account Disabled Successfully",
                        type: 'success'
                    })
                    window.location.reload();
                }

            }).catch((error) => {
                this.$toast.open({
                    message: "Error : " + error.response.data.message,
                    type: 'error'
                });
            })
    }
  },

  mounted() {
    this.$toast.open({
      message: "Processing : Loading Dashboard Data Please Wait...",
      type: "info",
    });

    const config = {
      headers: {
        Authorization: "Bearer " + this.fastAdminToken,
        "Content-Type": "application/json",
      },
    };


    axios
      .get(this.$apiURI + "/levels", config)
      .then((response) => {
        if (response.data.error) {
          this.$toast.open({
            message: "Error : " + response.data.message,
            type: "error",
          });
        } else {
          // eslint-disable-next-line no-console
          // console.log(response.data.data.teachers)
          let levels = response.data.data.levels;
          this.totalLevels = levels;
        }
      })
      .catch((error) => {
        this.$toast.open({
          message: "Error : " + error.response.data.message,
          type: "error",
        });
      });

      
    axios
      .get(this.$apiURI + "/groups", config)
      .then((response) => {
        if (response.data.error) {
          this.$toast.open({
            message: "Error : " + response.data.message,
            type: "error",
          });
        } else {
          let groups = response.data.data.groups;
          this.totalGroups = groups;
        }
      })
      .catch((error) => {
        this.$toast.open({
          message: "Error : " + error.response.data.message,
          type: "error",
        });
      });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.cascading-admin-card {
  margin: 20px 0;
  background: #1c2331 !important;
}

.btn:hover {
  color: #fff;
}

.cascading-admin-card .admin-up {
  margin-left: 4%;
  margin-right: 4%;
  margin-top: -20px;
  background: #1c2331 !important;
}

.cascading-admin-card .admin-up .fas,
.cascading-admin-card .admin-up .far {
  box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.2), 0 2px 13px 0 rgba(0, 0, 0, 0.19);
  padding: 1rem;
  font-size: 1rem;
  color: #fff;
  text-align: left;
  margin-right: 1rem;
  border-radius: 3px;
  background: #1c2331 !important;
}

.cascading-admin-card .admin-up .data {
  float: right;
  margin-top: 2rem;
  text-align: right;
}

.admin-up .data p {
  color: #999999;
  font-size: 12px;
}

.classic-admin-card .card-body {
  color: #fff;
  margin-bottom: 0;
  padding: 0.9rem;
}

.classic-admin-card .card-body p {
  font-size: 13px;
  opacity: 0.7;
  margin-bottom: 0;
}

.classic-admin-card .card-body h4 {
  margin-top: 10px;
}
</style>
